import { createContext } from 'react';

export const HistoryFilterContext = createContext({});